<template>
  <div id="main" class="app-main">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data () {
      return {}
    },
    mounted () {

    },
    beforeCreate () {
      document.querySelector('body').setAttribute('style', 'overflow: auto')
    },
    beforeDestroy () {

    },
    methods: {}
  }
</script>

<style lang="less">
  //@import "styles/common.less";

  .app-main {
    width: 100%;
    height: 100%;
    min-height: 550px;
  }
  /*
  99999s 基本上就是一个无限长的时间
  通过延长增加自动填充背景色的方式, 使用户感受不到样式的变化
*/
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-transition-delay: 99999s;
    -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
  }
</style>



// WEBPACK FOOTER //
// src/app.vue